import { SubscriptionStatus } from '@dtos/Order'

export const SUBSCRIPTION_INITIATED_STATUS: SubscriptionStatus = 'initiated'
export const SUBSCRIPTION_ACTIVE_STATUS: SubscriptionStatus = 'active'
export const SUBSCRIPTION_INACTIVE_STATUS: SubscriptionStatus = 'inactive'
export const SUBSCRIPTION_PAST_DUE_STATUS: SubscriptionStatus = 'past_due'
export const SUBSCRIPTION_CANCELLED_STATUS: SubscriptionStatus = 'cancelled'
export const SUBSCRIPTION_ENDED_STATUS: SubscriptionStatus = 'ended'
